import PersonalDocumentsView from './PersonalDocumentsView';
export default PersonalDocumentsView;
